module.exports = __webpack_public_path__ + "media/images/remember-favicon-5bd8a419510ef80399360c034f68a13c.png";